import { CreditCard } from '@phosphor-icons/react/dist/ssr';

import { ButtonElement } from '@/subscriptionManagementElements/shared/buttonElement/ButtonElement';
import type { DreamRenderElementProps } from '@/types';

export interface CardDetailsProps {
  brand?: string; // e.g. 'Visa'
  last4?: string; // e.g. '4424'
  onClickUpdate?: () => void;
  isLoading?: boolean;
  translations?: DreamRenderElementProps<any>['translations'];
}

export function CardDetails({ brand, last4, onClickUpdate, isLoading, translations }: CardDetailsProps) {
  return (
    <div className="w-full flex flex-col gap-2">
      <label className="text-gray-900 font-medium text-sm leading-5" htmlFor="card-details">
        {translations?.['billing.details.payment_method_heading']}*
      </label>
      <div className="flex flex-row items-center w-full gap-2">
        <div className="flex flex-1 gap-2 items-center bg-[#F3F4F6] border border-gray-200 rounded-md shadow-sm px-3 py-2">
          <CreditCard size={16} className="text-[#6B7280]" weight="fill" />
          <span className="text-gray-400 text-sm leading-5 font-normal capitalize">
            {brand ? `${brand} ****${last4}` : translations?.['billing.details.no_card']}
          </span>
        </div>
        <ButtonElement disabled={isLoading} onClick={onClickUpdate} variant="default">
          {translations?.['billing.details.update_button_label']}
        </ButtonElement>
      </div>
    </div>
  );
}
